import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Textfield from "../../shared/textfield";
import { pcolor, textFieldTitle, title } from "../../../style2";

export default function FamilySocialInformation(props) {
  const [disabledField, setDisabledField] = useState(true);
  const [doYouHaveAnotherVisitor, setDoYouHaveAnotherVisitor] = useState("yes");

  const handleEdit = () => {
    setDisabledField(!disabledField);
    if (!disabledField) {
      // To save changes here
    }
  };

  const handleCancelEdit = () => {
    setDisabledField(true);
  };

  const handleDoYouHaveAnotherVisitor = (event) => {
    setDoYouHaveAnotherVisitor(event.target.value);
  };

  const profile = props.profile;

  return (
    <Box ml={2} mr={2} mb={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={title}>Family history</Typography>
        </Grid>
        {profile.familyInformation?.siblingsWithAge && profile.familyInformation?.siblingsWithAge !== "" ?
          <Grid item xs={12} sm={6}>
            <Textfield
              title='Siblings with age'
              value={profile.familyInformation?.siblingsWithAge}
              disabled={disabledField}
            />
          </Grid> : null}
        {profile.familyInformation?.guardians && profile.familyInformation?.guardians !== "" ?
          <Grid item xs={12} sm={6}>
            <Textfield
              title='Guardians/ Carer(s)'
              value={profile.familyInformation?.guardians}
              disabled={disabledField}
            />
          </Grid> : null}
        {profile.familyInformation?.smokingHabits && profile.familyInformation?.smokingHabits !== "" ?
          <Grid item xs={12} sm={6}>
            <Textfield title='Smoking habits' value={profile.familyInformation?.smokingHabits} disabled={disabledField} />
          </Grid> : null}
        {profile.familyInformation?.pets && profile.familyInformation?.pets !== "" ?
          <Grid item xs={12} sm={6}>
            <Textfield title='Pets' value={profile.familyInformation?.pets} disabled={disabledField} />
          </Grid> : null}

      </Grid>
      <Box m={2} />
      <Divider />
      <Box m={2} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={title}>Social History</Typography>
        </Grid>
        {profile.familyInformation?.impactOfIllnessOnFamily && profile.familyInformation?.impactOfIllnessOnFamily !== "" ?
          <Grid item xs={12}>
            <Textfield
              title='Impact of this illness on the family?'
              value={profile.familyInformation?.impactOfIllnessOnFamily}
              disabled={disabledField}
            />
          </Grid> : null}
        {profile.familyInformation?.haveHealthVisitor ?
          <Grid item xs={12} sm={4}>

            <FormControl>
              <FormLabel sx={{ color: pcolor }}>Do you have a health visitor/social worker?</FormLabel>
              <RadioGroup row value={String(profile.familyInformation?.haveHealthVisitor)} onChange={handleDoYouHaveAnotherVisitor}>
                <FormControlLabel value='true' control={<Radio />} label='Yes' disabled={disabledField} />
                <FormControlLabel value='false' control={<Radio />} label='No' disabled={disabledField} />
              </RadioGroup>
            </FormControl>
          </Grid> : null}

        {doYouHaveAnotherVisitor === "yes" && profile.familyInformation?.healthVisitorInformation && profile.familyInformation?.healthVisitorInformation !== "" ?
          <Grid item xs={12} sm={8}>
            <Textfield
              title='Health visitor/social worker details'
              value={profile.familyInformation?.healthVisitorInformation}
              disabled={disabledField}
            />
          </Grid> : null
        }
      </Grid>
      {/* <Box m={2} />
      <Grid container alignItems='center' justifyContent='flex-end'>
        {!disabledField && (
          <>
            <Button
              type='submit'
              className={classes.buttonRed}
              onClick={handleCancelEdit}
            >
              Cancel
            </Button>
            <Box m={2} />
          </>
        )}
        <Button
          type='submit'
          className={classes.buttonRed}
          onClick={handleEdit}
        >
          {disabledField ? "Edit Profile" : "Save Changes"}
        </Button>
      </Grid> */}
    </Box>
  );
}
